// import {
//   Grid,
// } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import AddIcon from '@mui/icons-material/Add';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import { WSIcons } from "../../commonFunctions/iIcons";
// import { useNavigate } from "react-router-dom";
// import { getLocalValue, LoacalVariables, IsSmallScreen, updateMainHeader } from "../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import WSButton from "../../Components/Button/WSButton";
// import WSDashboardCard from "../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
// import WSDataGridNew, { IColumns } from "../../Components/DataGrid/WSDataGridNew";
// import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
// import http from "../../commonFunctions/httpClient";
// import config from '../../Config/clientConfig.json'

// interface Product {
//   id: string;
//   name: string;
//   brandName: string;
//   mode: string;
//   price: string;
//   stockQuantity: number;
//   status: string;
//   stockStatus: string;
//   isActive?: boolean;
// }

// export const VendorProductList: React.FC<any> = React.memo((props) => {
//   const navigate = useNavigate();
//   const isMobile = IsSmallScreen();
//   const [vendorId, setVendorId] = useState<string>("");
//   const [products, setProducts] = useState<Product[]>([]);
//   const [allProducts, setAllProducts] = useState<Product[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedFilter, setSelectedFilter] = useState<string>('All');
//   const [dashboardCounts, setDashboardCounts] = useState({
//     total: 0,
//     inStock: 0,
//     lowStock: 0,
//     outStock: 0
//   });

//   // ✅ FIXED: WSFilterButtonGroup expects STRING array
//   const filters = ['All', 'In Stock', 'Low Stock', 'Out Of Stock'];

//   // ✅ Calculate proper stock status
//   const calculateStockStatus = (stockQty: number): string => {
//     if (stockQty === 0) return 'Out Of Stock';
//     if (stockQty <= 5) return 'Low Stock';
//     return 'In Stock';
//   };

//   // Update header and breadcrumbs
//   useEffect(() => {
//     updateMainHeader('My Products');
//     breadCrumbsStore.updateBreadCrumbs([
//       { 'My Products': '/' },
//     ]);
//   }, []);

//   // Get vendorId from localStorage
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     console.log('🚀 Vendor ID:', userId);
//     setVendorId(userId || "");
//   }, []);

//   // ✅ FIXED: Fetch ALL products ONCE, filter client-side
//   const fetchProducts = useCallback(async () => {
//     if (!vendorId) {
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       console.log('📡 Fetching ALL products for vendor:', vendorId);
//       const endpoint = `pharmacy/products/Vendor/${vendorId}`;
//       const response: any = await http.get(endpoint);
//       console.log("✅ API Response:", response);
      
//       let rawData: Product[] = [];
//       const productsArray = Array.isArray(response.data) ? response.data : 
//                            Array.isArray(response) ? response : [];
      
//       if (productsArray.length > 0) {
//         // Filter out inactive products FIRST
//         const activeProducts = productsArray.filter((product: any) => product.isActive !== false);
        
//         // Map ALL active products
//         rawData = activeProducts.map((product: any) => ({
//           id: product.id || "",
//           name: product.productName || product.brandName || "N/A",
//           brandName: product.brandName || "N/A",
//           mode: product.productType || "N/A",
//           price: product.sellingPrice ? 
//                  `${config.currencyConfig}${Number(product.sellingPrice || 0).toFixed(2)}` : 
//                  `${config.currencyConfig}0.00`,
//           stockQuantity: product.stockQuantity || 0,
//           status: product.isActive ? "Active" : "Inactive",
//           stockStatus: calculateStockStatus(product.stockQuantity || 0),
//           isActive: product.isActive
//         }));

//         // Store ALL products
//         setAllProducts(rawData);
        
//         // Calculate dashboard counts
//         const total = rawData.length;
//         const inStock = rawData.filter(p => p.stockStatus === 'In Stock').length;
//         const lowStock = rawData.filter(p => p.stockStatus === 'Low Stock').length;
//         const outStock = rawData.filter(p => p.stockStatus === 'Out Of Stock').length;
        
//         setDashboardCounts({ total, inStock, lowStock, outStock });
//         console.log("✅ Dashboard Counts:", { total, inStock, lowStock, outStock });
//       }
      
//       setLoading(false);
//     } catch (error: any) {
//       console.error("💥 API ERROR:", error);
//       setAllProducts([]);
//       setProducts([]);
//       setDashboardCounts({ total: 0, inStock: 0, lowStock: 0, outStock: 0 });
//       setLoading(false);
//     }
//   }, [vendorId]);

//   // Client-side filter when filter changes
//   const applyFilter = useCallback((filter: string) => {
//     console.log('🔄 Applying filter:', filter);
    
//     if (filter === 'All') {
//       setProducts(allProducts);
//     } else {
//       const filtered = allProducts.filter(product => product.stockStatus === filter);
//       setProducts(filtered);
//     }
    
//     console.log('✅ Filtered to', filter, ':', products.length, '→', allProducts.filter(p => p.stockStatus === filter).length);
//   }, [allProducts]);

//   // Load data when vendorId ready
//   useEffect(() => {
//     if (vendorId) {
//       fetchProducts();
//     }
//   }, [vendorId, fetchProducts]);

//   // Filter changes trigger client-side filtering
//   useEffect(() => {
//     if (allProducts.length > 0) {
//       applyFilter(selectedFilter);
//     }
//   }, [selectedFilter, applyFilter, allProducts.length]);

//   // Safe delete handler
//   const handleDelete = useCallback(async (id?: string) => {
//     if (!id) return;
    
//     try {
//       if (!window.confirm("Are you sure you want to delete this product?")) {
//         return;
//       }
      
//       console.log("🗑️ DELETING PRODUCT:", id);
//       const response: any = await http.del(`pharmacy/products/${id}`);
//       console.log("🗑️ DELETE RESPONSE:", response);
      
//       if (response?.success !== false) {
//         alert('✅ Product deleted successfully!');
//         await fetchProducts();
//       } else {
//         alert(response?.message || 'Delete failed');
//       }
//     } catch (error: any) {
//       console.error("💥 DELETE ERROR:", error);
//       alert('❌ Failed to delete: ' + (error.response?.data?.message || error.message || 'Unknown error'));
//     }
//   }, [fetchProducts]);

//   // Safe action handler
//   const handleAction = useCallback((action: string, row: Product) => {
//     console.log("🔧 ACTION:", action, "ROW:", row);
    
//     if (!row || !row.id) {
//       alert("Invalid product data");
//       return;
//     }
    
//     switch (action) {
//       case "View":
//         navigate(`/vendor-product-view/${row.id}`);
//         break;
//       case "Edit":
//         navigate(`/vendor-product/edit/${row.id}`);
//         break;
//       case "Delete":
//         handleDelete(row.id);
//         break;
//       default:
//         console.warn("Unknown action:", action);
//     }
//   }, [navigate, handleDelete]);

//   const handleAddProduct = useCallback(() => {
//     navigate(`/vendor-product/add`);
//   }, [navigate]);

//   // ✅ FIXED: Return STRING array with counts for WSFilterButtonGroup
//   const getFilterLabels = useCallback((): string[] => {
//     const total = dashboardCounts.total;
//     const inStock = allProducts.filter(p => p.stockStatus === 'In Stock').length;
//     const lowStock = allProducts.filter(p => p.stockStatus === 'Low Stock').length;
//     const outStock = allProducts.filter(p => p.stockStatus === 'Out Of Stock').length;
    
//     return [
//       `All (${total})`,
//       `In Stock (${inStock})`,
//       `Low Stock (${lowStock})`,
//       `Out Of Stock (${outStock})`
//     ];
//   }, [dashboardCounts.total, allProducts]);

//   // ✅ FIXED: Parse string label back to filter value
//   const handleFilterChange = useCallback((selectedLabel: string) => {
//     console.log('🔄 Filter clicked:', selectedLabel);
    
//     // Extract filter value from "In Stock (3)" → "In Stock"
//     const filterValue = selectedLabel.split(' (')[0];
//     console.log('🔄 Applying filter:', filterValue);
//     setSelectedFilter(filterValue);
//   }, []);

//   const columns: IColumns[] = [
//     { header: "Name", fieldName: "name", type: "default" },
//     { header: "Brand", fieldName: "brandName", type: "default", isHide: isMobile },
//     { header: "Type", fieldName: "mode", type: "default", isHide: isMobile },
//     { 
//       header: "Price", 
//       fieldName: "price", 
//       type: "default", 
//       isHide: isMobile,
//     },
//     { header: "Stock", fieldName: "stockQuantity", type: "default" },
//     { header: "Status", fieldName: "status", type: "status", isHide: isMobile },
//     { header: "Stock Status", fieldName: "stockStatus", type: "status" },
//     { 
//       header: "Actions", 
//       fieldName: "actions", 
//       type: "action", 
//       actions: ["View", "Edit", "Delete"],
//       actionCallback: handleAction 
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Stock Status",
//       fieldName: "stockStatus",
//       type: "dropdown",
//       options: [
//         { label: "In Stock", value: "In Stock" },
//         { label: "Low Stock", value: "Low Stock" },
//         { label: "Out Of Stock", value: "Out Of Stock" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//   ];

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <div>Loading products...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container spacing={2}>
//         {/* Dashboard Cards */}
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Products"
//             value={dashboardCounts.total.toString()}
//             percentage="+2.5%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<ShoppingCartIcon sx={{ color: '#098963' }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="In Stock"
//             value={dashboardCounts.inStock.toString()}
//             percentage="+1.2%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.InStockIcon sx={{ color: '#098963' }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Low Stock"
//             value={dashboardCounts.lowStock.toString()}
//             percentage="-0.8%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: '#ff9800' }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Out Of Stock"
//             value={dashboardCounts.outStock.toString()}
//             percentage="+3.1%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: 'red' }} />}
//           />
//         </Grid>

//         {/* ✅ FIXED Filter + Add Button - STRINGS ONLY */}
//         <Grid item sm={9}>
//           <WSFilterButtonGroup 
//             options={getFilterLabels()}  // ✅ STRING[]
//             selected={getFilterLabels().find(label => label.startsWith(selectedFilter)) || `All (${dashboardCounts.total})`}
//             onChange={handleFilterChange}
//           />
//         </Grid>
//         <Grid item sm={3} display="flex" justifyContent="flex-end">
//           <WSButton 
//             id="btnAddNewProduct" 
//             label="Add New Product" 
//             startIcon={<AddIcon />} 
//             onClick={handleAddProduct}
//             sx={{
//               borderRadius: '999px',
//               backgroundColor: '#098963!important',
//               textTransform: 'none',
//               fontWeight: 500,
//               height: '35px!important',
//               fontSize: '0.875rem!important',
//               paddingX: 3,
//               paddingY: 1,
//               '&:hover': {
//                 backgroundColor: '#087654!important',
//               },
//             }}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           <WSDataGridNew
//             columns={columns}
//             id="vendorProductListGrid"
//             title={`My Products - ${selectedFilter} (${products.length})`}
//             exportCsv={true}
//             data={products}
//             filterFields={filterRows}
//             searchBox={{ fieldName: 'name' }}
//             addButton={{ label: "New", color: "secondary" }}
//             onAddButtonClick={handleAddProduct}
//             gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
//           />
//         </Grid>
//       </Grid>
//     </>
//   );
// });

// export default VendorProductList;



import {
  Grid,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import AddIcon from '@mui/icons-material/Add';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import { getLocalValue, LoacalVariables, IsSmallScreen, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSButton from "../../Components/Button/WSButton";
import WSDashboardCard from "../../Components/CardListing/WSDashboardCard";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import WSDataGridNew, { IColumns } from "../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
import http from "../../commonFunctions/httpClient";
import config from '../../Config/clientConfig.json'

interface Product {
  id: string;
  name: string;
  brandName: string;
  mode: string;
  price: string;
  stockQuantity: number;
  status: string;
  stockStatus: string;
  isActive?: boolean;
}

export const VendorProductList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const [vendorId, setVendorId] = useState<string>("");
  const [products, setProducts] = useState<Product[]>([]);
  const [allProducts, setAllProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState<string>('All');

  // ✅ Calculate dashboard counts from allProducts using useMemo
  const dashboardCounts = useMemo(() => {
    const total = allProducts.length;
    const inStock = allProducts.filter(p => p.stockStatus === 'In Stock').length;
    const lowStock = allProducts.filter(p => p.stockStatus === 'Low Stock').length;
    const outStock = allProducts.filter(p => p.stockStatus === 'Out Of Stock').length;
    
    return { total, inStock, lowStock, outStock };
  }, [allProducts]);

  // ✅ FIXED: Proper stock status mapping from API values
  const normalizeStockStatus = (apiStatus: any, stockQty: number): string => {
    // Handle API inconsistencies (string, number, etc.)
    if (!apiStatus || stockQty === 0) return 'Out Of Stock';
    if (stockQty <= 5) return 'Low Stock';
    
    const status = String(apiStatus).toLowerCase();
    if (status.includes('outofstock') || status.includes('out')) return 'Out Of Stock';
    if (status.includes('limitedstock') || status.includes('limited')) return 'Low Stock';
    if (status.includes('instock') || status.includes('in')) return 'In Stock';
    
    // Fallback to quantity-based logic
    return stockQty > 5 ? 'In Stock' : stockQty > 0 ? 'Low Stock' : 'Out Of Stock';
  };

  // ✅ Filter labels with memoization
  const filterLabels = useMemo(() => [
    `All (${dashboardCounts.total})`,
    `In Stock (${dashboardCounts.inStock})`,
    `Low Stock (${dashboardCounts.lowStock})`,
    `Out Of Stock (${dashboardCounts.outStock})`
  ], [dashboardCounts]);

  // Update header and breadcrumbs
  useEffect(() => {
    updateMainHeader('My Products');
    breadCrumbsStore.updateBreadCrumbs([
      { 'My Products': '/' },
    ]);
  }, []);

  // Get vendorId from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log('🚀 Vendor ID:', userId);
    setVendorId(userId || "");
  }, []);

  // ✅ FIXED: Enhanced API data processing
  const fetchProducts = useCallback(async () => {
    if (!vendorId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log('📡 Fetching products for vendor:', vendorId);
      const endpoint = `pharmacy/products/Vendor/${vendorId}`;
      const response: any = await http.get(endpoint);
      console.log("✅ API Response:", response);
      
      let rawData: Product[] = [];
      const productsArray = Array.isArray(response.data) ? response.data : 
                           Array.isArray(response) ? response : [];
      
      if (productsArray.length > 0) {
        // Filter out inactive/deleted products FIRST
        const activeProducts = productsArray.filter((product: any) => 
          product.isActive === true && product.isDeleted !== true
        );
        
        // ✅ FIXED: Handle your exact API response structure
        rawData = activeProducts.map((product: any) => ({
          id: product.id || "",
          name: product.productName || product.brandName || "N/A",
          brandName: product.brandName || "N/A",
          mode: product.productType || "N/A",
          price: product.sellingPrice ? 
                 `${config.currencyConfig}${Number(product.sellingPrice || 0).toFixed(2)}` : 
                 `${config.currencyConfig}0.00`,
          stockQuantity: Number(product.stockQuantity) || 0,
          status: product.isActive ? "Active" : "Inactive",
          // ✅ FIXED: Proper stockStatus normalization
          stockStatus: normalizeStockStatus(product.stockStatus, Number(product.stockQuantity) || 0),
          isActive: product.isActive
        }));

        console.log("✅ Processed Products:", rawData.slice(0, 3)); // Log first 3
        setAllProducts(rawData);
      }
      
      setLoading(false);
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setAllProducts([]);
      setProducts([]);
      setLoading(false);
    }
  }, [vendorId]);

  // Client-side filter
  const applyFilter = useCallback((filter: string) => {
    console.log('🔄 Applying filter:', filter);
    
    if (filter === 'All') {
      setProducts(allProducts);
    } else {
      const filtered = allProducts.filter(product => product.stockStatus === filter);
      setProducts(filtered);
    }
  }, [allProducts]);

  // Load data when vendorId ready
  useEffect(() => {
    if (vendorId) {
      fetchProducts();
    }
  }, [vendorId, fetchProducts]);

  // Apply filter when filter changes or data loads
  useEffect(() => {
    if (allProducts.length > 0) {
      applyFilter(selectedFilter);
    }
  }, [selectedFilter, applyFilter, allProducts]);

  const handleDelete = useCallback(async (id?: string) => {
    if (!id || !window.confirm("Are you sure you want to delete this product?")) {
      return;
    }
    
    try {
      console.log("🗑️ DELETING PRODUCT:", id);
      const response: any = await http.del(`pharmacy/products/${id}`);
      
      if (response?.success !== false) {
        alert('✅ Product deleted successfully!');
        await fetchProducts();
      } else {
        alert(response?.message || 'Delete failed');
      }
    } catch (error: any) {
      console.error("💥 DELETE ERROR:", error);
      alert('❌ Failed to delete: ' + (error.response?.data?.message || error.message || 'Unknown error'));
    }
  }, [fetchProducts]);

  const handleAction = useCallback((action: string, row: Product) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    if (!row?.id) {
      alert("Invalid product data");
      return;
    }
    
    switch (action) {
      case "View":
        navigate(`/vendor-product-view/${row.id}`);
        break;
      case "Edit":
        navigate(`/vendor-product/edit/${row.id}`);
        break;
      case "Delete":
        handleDelete(row.id);
        break;
      default:
        console.warn("Unknown action:", action);
    }
  }, [navigate, handleDelete]);

  const handleAddProduct = useCallback(() => {
    navigate(`/vendor-product/add`);
  }, [navigate]);

  // ✅ FIXED: Simplified filter handling - direct filter value mapping
  const handleFilterChange = useCallback((selectedLabel: string) => {
    const filterValue = selectedLabel.split(' (')[0]; // "In Stock (3)" → "In Stock"
    console.log('🔄 Filter selected:', filterValue);
    setSelectedFilter(filterValue);
  }, []);

  const columns: IColumns[] = [
    { header: "Name", fieldName: "name", type: "default" },
    { header: "Brand", fieldName: "brandName", type: "default", isHide: isMobile },
    { header: "Type", fieldName: "mode", type: "default", isHide: isMobile },
    { 
      header: "Price", 
      fieldName: "price", 
      type: "default", 
      isHide: isMobile,
    },
    { header: "Stock", fieldName: "stockQuantity", type: "default" },
    { header: "Status", fieldName: "status", type: "status", isHide: isMobile },
    { header: "Stock Status", fieldName: "stockStatus", type: "status" },
    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["View", "Edit", "Delete"],
      actionCallback: handleAction 
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Stock Status",
      fieldName: "stockStatus",
      type: "dropdown",
      options: [
        { label: "In Stock", value: "In Stock" },
        { label: "Low Stock", value: "Low Stock" },
        { label: "Out Of Stock", value: "Out Of Stock" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
  ];

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading products...</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        {/* Dashboard Cards */}
        <Grid item sm={3}>
          <WSDashboardCard
            title="Total Products"
            value={dashboardCounts.total.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<ShoppingCartIcon sx={{ color: '#098963' }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="In Stock"
            value={dashboardCounts.inStock.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<WSIcons.InStockIcon sx={{ color: '#098963' }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Low Stock"
            value={dashboardCounts.lowStock.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<WSIcons.OutOfStockIcon sx={{ color: '#ff9800' }} />}
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard
            title="Out Of Stock"
            value={dashboardCounts.outStock.toString()}
            percentage=""
            bottomIcon={<TrendingUpIcon />}
            icon={<WSIcons.OutOfStockIcon sx={{ color: 'red' }} />}
          />
        </Grid>

        {/* Filter + Add Button */}
        <Grid item sm={9}>
          <WSFilterButtonGroup 
            options={filterLabels}
            selected={filterLabels.find(label => label.startsWith(selectedFilter)) || filterLabels[0]}
            onChange={handleFilterChange}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent="flex-end">
          <WSButton 
            id="btnAddNewProduct" 
            label="Add New Product" 
            startIcon={<AddIcon />} 
            onClick={handleAddProduct}
            sx={{
              borderRadius: '999px',
              backgroundColor: '#098963!important',
              textTransform: 'none',
              fontWeight: 500,
              height: '35px!important',
              fontSize: '0.875rem!important',
              paddingX: 3,
              paddingY: 1,
              '&:hover': {
                backgroundColor: '#087654!important',
              },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            id="vendorProductListGrid"
            title={`My Products - ${selectedFilter} (${products.length})`}
            exportCsv={true}
            data={products}
            filterFields={filterRows}
            searchBox={{ fieldName: 'name' }}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleAddProduct}
            gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
          />
        </Grid>
      </Grid>
    </>
  );
});

export default VendorProductList;
